// src/auth/SignOutRoute.js
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './SupabaseAuthProvider';

/**
 * A route component that automatically signs out the user and redirects to home
 * This component should be added to your routes: <Route path="/signout" element={<SignOutRoute />} />
 */
const SignOutRoute = () => {
  const { logout } = useAuth();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
      } catch (error) {
        console.error('Logout error:', error);
      }
    };

    performLogout();
  }, [logout]);

  // Immediately redirect to home page
  return <Navigate to="/" replace />;
};

export default SignOutRoute;
